import React, { useEffect, useState } from "react";
import { isMobile as libIsMobile, isTablet as libIsTablet } from "react-device-detect";
import { useLocation, useNavigate } from "react-router-dom";
import AppsIcon from "@mui/icons-material/Apps";
import {
  Drawer,
  Grid,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import TableChartIcon from "@mui/icons-material/TableChart";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import GroupIcon from '@mui/icons-material/Group';
import LogoutIcon from '@mui/icons-material/Logout';
import logo from "../../src/assets/loginLogo.png";
import Swal from "sweetalert2";

let isMobile = libIsMobile || libIsTablet || window.innerWidth < 1024;

const Navbar = () => {
  const [openSidebar, setOpenSidebar] = useState(false);
  const [menuAccess, setMenuAccess] = useState(true); // Default to true for better usability
  const navigate = useNavigate();
  const location = useLocation();

  // Menu items with corresponding routes
  const menuItem = [
    {
      icon: <TableChartIcon />,
      label: "Template List",
      redirect: "/main-layout",
    },
    {
      icon: <UploadFileIcon />,
      label: "Publish List",
      redirect: "/publish-template",
    },
    {
      icon: <GroupIcon />,
      label: "User Management",
      redirect: "/user-list",
    },
    {
      icon: <LogoutIcon />,
      label: "Log Out",
      onClick: () => logout(),
    },
  ];

  // Set menu access based on current URL path
  useEffect(() => {
    const urlContainsUserForm = location.pathname.includes("user-form");
    setMenuAccess(!urlContainsUserForm);
  }, [location]);

  // Logout function with confirmation
  const logout = () => {
    Swal.fire({
      text: "Do you want to log out?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#5149E4",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.removeItem("userToken");
        Swal.fire({
          title: "Logged Out",
          text: "You have successfully logged out.",
          icon: "success",
          confirmButtonText: "Okay",
        });
        navigate("/");
      }
    });
  };

  return (
    <>
      <header id="header" className="header-sticky sticky-active" data-fullwidth="true">
        <div className="header-inner" style={{ backgroundColor: "#96c9ff" }}>
          <div className="container">
            <div className="nav-spacing">
              <div id="logo">
                <a
                  href={menuAccess ? "/main-layout" : "#"}
                  className="logo vcenter"
                  data-src-dark="/img/logo_ke.png"
                  style={{ fontFamily: "Cassannet", fontSize: "16px" }}
                >
                  <img
                    src={logo}
                    alt="Form Dynamic"
                    style={isMobile ? { marginTop: "7px", display: "inline-block" } : { display: "inline-block" }}
                    className={isMobile ? "p-l-20 p-r-15" : "p-r-20"}
                  />
                </a>
              </div>
              {menuAccess && (
                <div style={{ cursor: "pointer" }} onClick={() => setOpenSidebar(!openSidebar)} aria-label="Toggle sidebar">
                  <AppsIcon fontSize="large" />
                </div>
              )}
            </div>
            <Drawer open={openSidebar} anchor="right" onClose={() => setOpenSidebar(false)}>
              <div
                style={{
                  minWidth: "3vw",
                  backgroundColor: "rgb(86, 146, 210)",
                  color: "#ffffff",
                  height: "100vh",
                }}
              >
                <div className="container">
                  <div className="m-0 p-0 d-flex align-items-center justify-content-between">
                    <Typography variant="h6" style={{ marginTop: "4px", color: "#ffffff" }}>
                      Menu
                    </Typography>
                    <CloseIcon
                      style={{
                        marginRight: "2px",
                        marginLeft: "2vw",
                        cursor: "pointer",
                      }}
                      onClick={() => setOpenSidebar(false)}
                      aria-label="Close sidebar"
                    />
                  </div>
                  <Grid container>
                    <List>
                      {menuItem.map((item, index) => (
                        <ListItem key={index} disablePadding>
                          <ListItemButton
                            onClick={() => {
                              if (item.onClick) {
                                item.onClick();
                              } else {
                                navigate(item.redirect);
                              }
                              setOpenSidebar(false);
                            }}
                          >
                            <ListItemIcon style={{ color: "#ffffff" }}>{item.icon}</ListItemIcon>
                            <ListItemText primary={item.label} />
                          </ListItemButton>
                        </ListItem>
                      ))}
                    </List>
                  </Grid>
                </div>
              </div>
            </Drawer>
          </div>
        </div>
      </header>
    </>
  );
};

export default Navbar;
